import AppUtils from 'src/utils/AppUtils';
import { sendEventToAloha, updateAppointmentUserReference } from 'src/utils/Integrations';

import ClientsDB from './clients-db';
import GenericDB from './generic-db';
import UsersClientsDB from './usersClients-db';
import UsersDeletionsDB from './usersDeletions-db';

export default class UsersDB extends GenericDB {
  constructor() {
    super('users');
  }

  async disableUser(userId, staffMemberId) {
    if (staffMemberId) {
      const clientsDb = new ClientsDB();
      await clientsDb.set({ status: 'inactive' }, staffMemberId);
    }

    return this.set({ status: 'inactive' }, userId);
  } // disableUser()

  enableUser(userId) {
    return this.set({ status: 'active' }, userId);
  } // enableUser()

  async deleteUserPromise(userId) {
    // We need to update the `updateBy` field of the user before deleting it to make sure we have valid audit trail
    await this.update({ id: userId });
    await this.delete(userId);
    return { isUserDeleted: true };
  } // deleteUserPromise()

  /**
   * Delete a user including usersClients relationships
   * Create a users deletions document
   * @param {Object} deletionsData
   * @returns {Promise<{status: 'fulfilled' | 'rejected', value?: any, reason?: any}[]>}
   */
  async deleteUser(deletionsData) {
    const usersDeletionsDb = new UsersDeletionsDB();
    const usersClientsDb = new UsersClientsDB();

    const { deletedUserId, connectedClinic, integrationReference } = deletionsData;
    const deleteUsersClients = await usersClientsDb.readAll([['user', '==', deletedUserId]]);

    const actions = [];

    if (connectedClinic?.integration === 'aloha' && integrationReference) {
      actions.push(...[
        updateAppointmentUserReference(connectedClinic.id, integrationReference, {
          userId: null,
          userName: null,
        }),
        sendEventToAloha(connectedClinic.id, 'MemberMappingsRemoved', { refId: integrationReference }),
      ]);
    }

    actions.push(...[
      deleteUsersClients.map((userClient) => usersClientsDb.delete(userClient.id)),
      usersDeletionsDb.create(deletionsData),
      this.deleteUserPromise(deletedUserId),
    ]);

    return AppUtils.allSettled(actions);
  } // deleteUser()

  // Here you can extend UsersDB with custom methods
}
